import {type RefObject, useCallback, useContext} from 'react';
import { GlobalToastContext } from '@higherlogic/ocfe/src/toast';
import { copyToClipboard } from '@higherlogic/ocfe/src/webUtils';

/// Copy a string to clipboard. Display a success message, then focus the previous active element.
/// Optionally pass a ref to be used as the container for the copy input element (document.body by default)
/// Optionally use the ref object to focus instead of the previous active element
export const useCopyStringToClipboard = (
  url: string | undefined,
  message: string,
  ref?: RefObject<HTMLElement>,
  focusRefElement?: boolean
) => {
  const globalToast = useContext(GlobalToastContext);
  return useCallback(() => {
    if (url) {
      copyToClipboard(url, ref?.current, focusRefElement);
      globalToast({ message: message, type: 'success' });
    }
  }, [url, ref, globalToast, message]);
};
